import { render, staticRenderFns } from "./SdRegion.vue?vue&type=template&id=42505db7&scoped=true"
import script from "./SdRegion.vue?vue&type=script&lang=js"
export * from "./SdRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42505db7",
  null
  
)

export default component.exports